import { HttpClient, HttpParams } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { catchError, map, Observable, throwError } from "rxjs"
import { environment } from 'src/environments/environment';
import { ActivityLogResponse, ActivityParams } from "src/models/activity.interface";
import { BillingProcess, ListBillingProcess } from "src/models/billingProcess.interface";
import { BillingResponse } from "src/models/bills-list.interface";
import { ListMasterBillingConcept, MasterBillingConcept } from "src/models/masterBillingConcept.interface";
import { ProvidersFailed } from "src/models/ProviderFailed";

@Injectable({
    providedIn: 'root',
})
export class BillingService {

    public rolEmitter: EventEmitter<string> = new EventEmitter();
    public selectedProviderId: number | undefined;

    constructor(
        private http: HttpClient,
    ) { }

    sendBillingInfoToBillers(data: any): Observable<any> {
        const url = `${environment.API_URL}/api/v1/billings/billingProcess/sendAllBillingData`;
        const sendData: any = {
            startDate: data.startDate,
            endDate: data.endDate,
            clientCode: data.clientCode,
            cif: data.cif,
        };

        return this.http.post<any>(url, sendData);
    }

    createMasterBillingConcept(concept: MasterBillingConcept): Observable<any> {
        const url = `${environment.API_URL}/api/v1/crm/billingConcepts`;
        return this.http.post(url, concept);
    }
    getBillList(cif:any,date?:any,clientCode?:any):Observable<any>{
        let queryParams: any = {};

        if (date) {
            queryParams.date = date;
        }
        
        if (clientCode) {
            queryParams.clientCode = clientCode;
        }
   
    const url = `${environment.API_URL}/api/v1/billings/invoice/list/cif/${cif}`;
    return this.http.get<any>(url,{params:queryParams});
    }

    getListActivity(params?: ActivityParams, page: number = 1): Observable<ActivityLogResponse> {
        const url = `${environment.API_URL}/api/v1/billings/eventRegistry`;
        let queryParams = new HttpParams().set('page', page.toString());

        if (params) {
            Object.keys(params).forEach((key) => {
                const value = params[key as keyof ActivityParams];
                if (value !== undefined && value !== null) {
                    queryParams = queryParams.append(key, value.toString());
                }
            });
        }

        return this.http.get<ActivityLogResponse>(url, { params: queryParams });
    }

    getBillingEvents(params?: ActivityParams): Observable<ActivityLogResponse> {
        const url = `${environment.API_URL}/api/v1/billings/eventRegistry`;
        let queryParams = new HttpParams();

        if (params) {
            Object.keys(params).forEach((key) => {
                const value = params[key as keyof ActivityParams];
                if (value !== undefined && value !== null) {
                    queryParams = queryParams.append(key, value.toString());
                }
            });
        }

        if (params?.billingStartDate) {
            queryParams = queryParams.append(
                'billingStartDate',
                params.billingStartDate
            );
        }
        if (params?.billingEndDate) {
            queryParams = queryParams.append(
                'billingEndDate',
                params.billingEndDate
            );
        }
        if (params?.provider_id) {
            queryParams = queryParams.append(
                'providerId',
                params.provider_id.toString()
            );
        }

        return this.http.get<ActivityLogResponse>(url, { params: queryParams });
    }

    getBillingDownload(fileName:any): Observable<any> {
        const url = `${environment.API_URL}/api/v1/billings/invoice/file/${fileName}`;
        return this.http.get(url, { responseType: 'blob' });
    }





    getBills(page: number): Observable<BillingResponse> {
        console.log(page)
        const params = new HttpParams().set('page', page.toString());
        const url = `${environment.API_URL}/api/v1/billings/deliveryNote`;
        return this.http.get<BillingResponse>(url, { params });
    }


    getClientCodes(organizationCif: string): Observable<any> {
        const url = `${environment.API_URL}/api/v1/billings/clientCodes/${organizationCif}`;
        return this.http.get<any>(url);
    }

    sendProviderBillingData(data: any): Observable<any> {
        const url = `${environment.API_URL}/api/v1/billings/billingProcess/sendProviderBillingData`;
        return this.http.post<any>(url, data);
    }

    sendAllBillingData(billingData: any): Observable<any> {
        const url = `${environment.API_URL}/api/v1/billings/billingProcess/sendAllBillingData`;
        return this.http.post(url, billingData);
    }

    getBillingProcessDetails(id: string): Observable<BillingProcess> {
        const url = `${environment.API_URL}/api/v1/billings/billingProcess/${id}`;
        return this.http.get<BillingProcess>(url);
    }
    getMasterBillingConcept(page: number): Observable<ListMasterBillingConcept> {
        const url = `${environment.API_URL}/api/v1/crm/billingConcepts?page=${page}`;
        return this.http.get<ListMasterBillingConcept>(url);
    }

    getBillingProcesses(page: number): Observable<ListBillingProcess> {
        const url = `${environment.API_URL}/api/v1/billings/billingProcess?page=${page}`;
        return this.http.get<ListBillingProcess>(url).pipe(
            map((response: ListBillingProcess) => {
                response.results.sort((a: BillingProcess, b: BillingProcess) => new Date(b.date).getTime() - new Date(a.date).getTime());
                return response;
            }),
            catchError((error) => {
                console.error('Error fetching billing processes:', error);
                return throwError(() => new Error('Error fetching billing processes'));
            })
        );
    }

    getPendingProviders(): Observable<ProvidersFailed> {
        const url = `${environment.API_URL}/api/v1/billings/billingProcess/pendingProviders`;
        return this.http.get<ProvidersFailed>(url);
    }

}